import React from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import PageNotFound from "./PageNotFound";

const Index = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <PageNotFound />;
    }
    if (error.status === 401) {
      return <div>You aren't authorized to see this</div>;
    }
  }
};

export default Index;
